import NTopNBottom from '../../components/NTopNBottom'

import bannerImg from '../../assets/sunnySmile/banner.jpg'
import navColor from '../../assets/sunnySmile/nav/color.jpg'
import navBgFixed from '../../assets/sunnySmile/nav/nav_bg_fixed.png'

import far1 from '../../assets/sunnySmile/nav/far1.png'
import far1_active from '../../assets/sunnySmile/nav/far1_active.png'
import far2 from '../../assets/sunnySmile/nav/far2.png'
import far2_active from '../../assets/sunnySmile/nav/far2_active.png'
import far3 from '../../assets/sunnySmile/nav/far3.png'
import far3_active from '../../assets/sunnySmile/nav/far3_active.png'

import son1 from '../../assets/sunnySmile/nav/son1.png'
import son1_active from '../../assets/sunnySmile/nav/son1_active.png'
import son2 from '../../assets/sunnySmile/nav/son2.png'
import son2_active from '../../assets/sunnySmile/nav/son2_active.png'
import son3 from '../../assets/sunnySmile/nav/son3.png'
import son3_active from '../../assets/sunnySmile/nav/son3_active.png'

import calcRemFn from '../calcRem'


const navCss = {
  navWrap: {
    paddingTop: 0,
    minHeight: calcRemFn(108.5),
    backgroundImage: `url(${navColor})`,
    boxSizing: 'border-box'
  },
  navCtnFixed: {
    height: calcRemFn(108.5),
    backgroundImage: `url(${navBgFixed})`,
  },
  topBtnLayout: {
    alignItems: 'center',
    paddingTop: `${calcRemFn(12)}`,
  },
  topBtnBaseCss: {
    width: calcRemFn(80),
    height: calcRemFn(27)
  },
  bottomBtnLayout: {
    justifyContent: 'center',
    padding: `0 ${calcRemFn(40)}`,
  },
  bottomBtnBaseCss: {
    padding: `${calcRemFn(20)} ${calcRemFn(10)} 0`,
    width: calcRemFn(80),
    height: calcRemFn(27)
  }
}

const navData = {
  component: NTopNBottom,
  top: [
    {
      key: 'top1',
      show: true,
      img: far1,
      img_actived: far1_active,
    },
    {
      key: 'top2',
      show: true,
      img: far2,
      img_actived: far2_active,
    },
    {
      key: 'top3',
      show: true,
      img: far3,
      img_actived: far3_active,
    }
  ],
  bottom: {
    top1: [
      {
        key: '_i1',
        show: true,
        img: son1,
        img_actived: son1_active
      },
      {
        key: '_i2',
        show: true,
        img: son2,
        img_actived: son2_active
      }
    ],
    top2: [
      {
        key: '_i1',
        show: true,
        img: son1,
        img_actived: son1_active
      },
      {
        key: '_i2',
        show: true,
        img: son2,
        img_actived: son2_active
      },
      {
        key: '_i3',
        show: true,
        img: son3,
        img_actived: son3_active
      }
    ],
    top3: [
      {
        key: '_i1',
        show: true,
        img: son1,
        img_actived: son1_active
      }
    ]
  }
}

const pictureList = [
  {
    key: '1_1',
    pid: 105958,
  },
  {
    key: '1_2',
    pid: 105959,
  },
  {
    key: '2_1',
    pid: 105958,
  },
  {
    key: '2_2',
    pid: 105959,
  },
  {
    key: '2_3',
    pid: 105959,
    picNum: 1,
  },
  {
    key: '3_1',
    pid: 105958,
  }
]

function handlePictures (pictureList) {
  const pictures = []
  pictureList.forEach(item => {
    const { picNum = 2, pid, key, startIndex = 0, type = 'blue', fun } = item
    const picList = []
    Array(picNum).fill(0).forEach((item, index) => {
      picList.push(require(`../../assets/sunnySmile/ctn/${key}_${index + startIndex + 1}.jpg`))
    })
    const indexArr = key.split('_')
    pictures.push({
      id: pid,
      type,
      ref: `top${indexArr[0]}_i${indexArr[1]}`,
      farName: `top${indexArr[0]}`,
      sonName: `_i${indexArr[1]}`,
      son: picList,
      ...(fun && { fun })
    })
  })
  return pictures
}
const pictures = handlePictures(pictureList)

pictures.push({
  id: '',
  son: [require(`../../assets/sunnySmile/ctn/4_1_1.jpg`)]
})


const topDiff = {
  firstSon: '_i1',
  top1_i1: 15,
  top1_i2: 55,
  top2_i2: 55,
  top2_i3: 55,
}

export default {
  title: '元气限定',
  bannerImg,
  navCss,
  navData,
  pictures,
  topDiff,
}
